import { getHeaders, PURCHASER_API_BASE_URL } from "../Constants";

export type APIKeyEnvironment = "live" | "test";

export type APIKey = {
    id: string;
    name: string;
    environment: APIKeyEnvironment;
    key_hint: string;
    last_used_at: string | null;
    expires_at: string | null;
    revoked_at: string | null;
    created_at: string;
    created_by: {
        id: string;
        name: string;
    };
};

export type CreatedAPIKey = {
    id: string;
    name: string;
    environment: APIKeyEnvironment;
    key: string;
    key_hint: string;
    created_at: string;
};

export default {
    listAPIKeys: (): Promise<APIKey[]> =>
        fetch(`${PURCHASER_API_BASE_URL}/api-keys`, {
            headers: getHeaders(),
            method: "GET",
        }).then(res => res.json()),

    createAPIKey: (params: { name: string; environment: APIKeyEnvironment; expires_at?: string }): Promise<CreatedAPIKey> =>
        fetch(`${PURCHASER_API_BASE_URL}/api-keys`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify(params),
        }).then(res => res.json()),

    revokeAPIKey: (keyId: string): Promise<APIKey> =>
        fetch(`${PURCHASER_API_BASE_URL}/api-keys/${keyId}/revoke`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({}),
        }).then(res => res.json()),
};
